const DISABLE_SCROLLING = 'global/DISABLE_SCROLLING';
const ENABLE_SCROLLING = 'global/ENABLE_SCROLLING';

export default {
  DISABLE_SCROLLING,
  ENABLE_SCROLLING
};
